import LabelWithToolTip from "@/components/LabelWithTooltip/LabelWithToolTip";
import { ProducedByDto } from "@/hooks/types";
import FormField from "@ingka/form-field";
import Label from "@ingka/label";
import { Option, Select } from "@ingka/select";
import { UpdateAssetDtoProducedByEnum } from "generated";

import { useMetadataFields } from "@/components/MetadataFields/hooks";
import {
  FieldAccessContext,
  isLockedForNonIngkaUser,
  isLockedForOwner,
  isUploadFinalized,
} from "@/components/MetadataFields/formFieldsAccessRules";

type ProducedByProps = {
  options: ProducedByDto;
  fieldAccessContext: FieldAccessContext;
};

export function ProducedBy({ options, fieldAccessContext }: ProducedByProps) {
  const {
    getValidationError,
    activeAsset,
    updateMetadata,
    isMetadataUpdating,
  } = useMetadataFields();
  const error = getValidationError("producedBy", activeAsset.id!);
  const isUpdating =
    isMetadataUpdating(activeAsset.id!, "producedBy") ||
    isMetadataUpdating(activeAsset.id!, "producerId") ||
    isMetadataUpdating(activeAsset.id!, "productionOrderedBy");
  const isDisabled =
    isLockedForOwner(fieldAccessContext) ||
    isUploadFinalized(fieldAccessContext) ||
    isLockedForNonIngkaUser(fieldAccessContext) ||
    isUpdating;

  return (
    <>
      <Label
        htmlFor="producedBy"
        label={
          <LabelWithToolTip
            labelText="Produced by"
            toolTipText={`Who has created the asset(s)?
    Internal local production: Content is created inhouse by a market.
    External agency: Content is created by an external agency.
    `}
          />
        }
      />
      <FormField
        valid="error"
        validation={{
          msg: error?.message,
          type: "error",
        }}
        shouldValidate={Boolean(error)}
      >
        <Select
          id="producedBy"
          value={activeAsset.producedBy || ""}
          disabled={isDisabled}
          onChange={(e) => {
            const producedBy = e.target.value || null;

            updateMetadata({
              producedBy: producedBy as UpdateAssetDtoProducedByEnum,
            });
          }}
        >
          {Object.entries(options).map(([name, label]) => (
            <Option key={name} name={label} value={name} />
          ))}
        </Select>
      </FormField>
    </>
  );
}
